import React from "react";
import {Box, Container, Typography, Button, Alert, Paper} from "@mui/material";
import {useAuth} from "../../contexts/AuthContext";
import {Link as RouterLink} from "react-router-dom";

const OnboardingPage: React.FC = () => {
  const {user, logout} = useAuth();

  return (
    <Container maxWidth="sm" sx={{mt: 8, display: "flex", flexDirection: "column", alignItems: "center"}}>
      <Paper elevation={3} sx={{p: 4, width: "100%", textAlign: "center"}}>
        <Typography variant="h5" fontWeight="bold" color="primary" gutterBottom>
          Access pending
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{mb: 2}}>
          Welcome{user?.name ? `, ${user.name}` : ""}.
        </Typography>
        <Alert
          severity="success"
          sx={{
            mb: 3,
            textAlign: "left",
            border: "3px solid #d32f2f",
            borderRadius: 1,
            bgcolor: "#rgb(248, 255, 244)",
            color: "#2e7d32",
            fontWeight: 600,
            "& .MuiAlert-icon": {color: "#2e7d32"},
            "& .MuiAlert-message": {color: "#2e7d32"},
          }}>
          Your access request has been submitted. An administrator will create the required setup and provide access.
        </Alert>
        <Typography variant="body2" color="text.secondary" paragraph>
          You will be able to sign in after a Super Admin assigns you to an organization.
        </Typography>
        <Box sx={{display: "flex", flexDirection: "column", gap: 1, mt: 2}}>
          <Button component={RouterLink} to="/request-access" variant="contained">
            Request Access
          </Button>
          <Button component={RouterLink} to="/login" variant="text">
            Back to Sign In
          </Button>
          {user && (
            <Button variant="text" color="inherit" onClick={() => logout()}>
              Sign Out
            </Button>
          )}
        </Box>
      </Paper>
    </Container>
  );
};

export default OnboardingPage;
